import styled from 'styled-components';
import { color } from 'styled-system';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import EditUserForm from './EditUserForm.jsx';
import Modal from '../../../../shared/Modal';
import DeleteUser from './DeleteUser.jsx';
import { Heading } from '../StyledComponents';
import { SITE_ADMIN } from '../../../../lib/utils/constants/UserTypes';

const Wrapper = styled.div`
  display: flex;
  font-family: 'Montserrat', sans-serif;
  margin: 0 0 8px;
  align-items: center;
`;

const DeleteUserLink = styled.a`
  ${color}
  margin-left: auto;
  font-weight: 600;
  font-size: 12px;
`;

const openDeleteUserModal = ({ uuid, name }) =>
  Modal({
    component: <DeleteUser userId={uuid} userName={name} />,
    width: '394px',
    padding: '24px',
  });

export default function ManageUser({ user }) {
  const { t } = useTranslation('users');
  const { email } = useSelector(state => state.currentUser);

  const { userType: currentUserType } = useSelector(state => state.currentUser);
  const canDestroy =
    email !== user.email &&
    ((!user.isOrgAdmin && currentUserType !== SITE_ADMIN) ||
      currentUserType === SITE_ADMIN);

  return (
    <section>
      <Wrapper>
        <Heading as="h2">{t('manageUser.editUser')}</Heading>
        {canDestroy && (
          <DeleteUserLink
            onClick={() => openDeleteUserModal(user)}
            color="primary.100"
          >
            {t('manageUser.deleteUser')}
          </DeleteUserLink>
        )}
      </Wrapper>
      <EditUserForm user={user} />
    </section>
  );
}
